import { BankIcon, VaultIcon } from "@phosphor-icons/react";
import { Col, Row } from "antd";
import { get } from "lodash";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import Container from "shared/components/Container";
import Section from "shared/components/Section";
import Select from "shared/components/Select";
import Typography from "shared/components/Typography";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import {
  ASSET_TYPES,
  CHAIN_TYPES,
  PAGINATION,
  PRODUCT_TYPES,
} from "utils/constants";
import { formatters } from "utils/helpers";
import Loading from "shared/components/Loading";
import Error from "shared/components/Error";

const Recent = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const TRANSACTIONS = t("SEND.TRANSACTIONS", { returnObjects: true });
  const { data, loading, error } = useQuery(graphql.queries.ASSETS, {
    variables: {
      where: {
        collateral: {
          escrow: { product: { type: PRODUCT_TYPES.XOB_LIQUIDITY.value } },
        },
      },
      take: PAGINATION.MICRO.TAKE,
      skip: PAGINATION.MICRO.SKIP,
    },
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    assets: { data: assets },
  } = data;

  return (
    <div className="recent__transfers">
      <Typography
        size="body"
        weight="regular"
        color="secondary"
        position="left"
      >
        {TRANSACTIONS.TITLE}
      </Typography>
      <div className="recent__transfers--list">
        {assets.map((asset) => {
          const { id, type } = asset;
          const balance = Number(get(asset, "amount", 0));
          const { icon: flag, mirror } = Object.values(ASSET_TYPES).find(
            (value) => value.type === type
          );
          return (
            <div
              key={id}
              className="recent__transfers--item"
              onClick={() => {}}
            >
              <div className="recent__transfers--item--type">
                <div className="--icon">{flag}</div>
                <div className="--content">
                  <span className="--balance">
                    <span className="--amount">
                      {formatters.amounts(balance)}
                    </span>
                    <span className="--currency">{mirror}</span>
                  </span>
                  <span className="--value">{type}</span>
                </div>
              </div>
              <div className="recent__transfers--item--account">
                <span className="--icon">
                  <BankIcon size={20} />
                </span>
                <span className="--address">
                  {formatters.addresses(
                    asset.action.configuration.addresses[0].value
                  )}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const Send = ({ assets }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.XO.ACCOUNT);
  const SEND = t("SEND", { returnObjects: true });

  return (
    <Container className="bg-white">
      <Row justify="center" gutter={[16, 16]}>
        <Col xs={24} sm={24} md={20} lg={16} xl={15} xxl={14}>
          <Section title={<Typography size="lg">{SEND.TITLE}</Typography>}>
            <Section.Fields>
              <Section.Field>
                <Select
                  onSelect={(item) => {}}
                  optionFilterProp="label"
                  type="async"
                  label={SEND.FORM.FIELDS.ACCOUNT.TITLE}
                  node={[
                    graphql.queries.ADDRESSES,
                    {
                      variables: {
                        where: {
                          token: {
                            chain: CHAIN_TYPES.FIAT,
                          },
                        },
                      },
                    },
                    "addresses.data",
                  ]}
                  placeholder={
                    <span className="select--placeholder">
                      <BankIcon size={24} />
                      <span className="select--placeholder--text">
                        {SEND.FORM.FIELDS.ACCOUNT.PLACEHOLDER}
                      </span>
                    </span>
                  }
                  format={(address) => (
                    <div className="select--option">
                      <span className="select--option--icon">
                        <VaultIcon />
                      </span>
                      <div className="select--option--content">
                        <span className="select--option--type">
                          {address.token.type}
                        </span>
                        <span className="select--option--value">
                          {formatters.addresses(address.value)}
                        </span>
                      </div>
                    </div>
                  )}
                />
              </Section.Field>
            </Section.Fields>
          </Section>
          <div className="pt-16" />
          <Recent assets={assets} />
        </Col>
      </Row>
    </Container>
  );
};

export default Send;
